module.exports = __webpack_public_path__ + "static/media/player_40p.ecf1a642.png";